import { Button, Modal, Space } from 'antd'
import { useEffect, useMemo } from 'react'

export interface PdfPreview {
  blob: Blob
  title: string
  fileName: string
}

/**
 * Shows a PDF inside the page. Opening it in a new tab after the request finishes counts as a pop-up (the click
 * that started it is long over), so browsers block it; a modal is never blocked. A new-tab link and a download
 * are offered from here, as direct clicks.
 */
const PdfPreviewModal = ({ preview, onClose }: { preview: PdfPreview | null; onClose: () => void }) => {
  const url = useMemo(
    () => (preview ? URL.createObjectURL(new Blob([preview.blob], { type: 'application/pdf' })) : null),
    [preview],
  )
  useEffect(() => () => { if (url) URL.revokeObjectURL(url) }, [url])

  return (
    <Modal
      open={!!preview}
      onCancel={onClose}
      title={preview?.title}
      width="min(960px, 96vw)"
      style={{ top: 24 }}
      destroyOnClose
      footer={
        url && (
          <Space>
            <Button href={url} target="_blank" rel="noreferrer">
              新标签页打开
            </Button>
            <Button href={url} download={preview?.fileName}>
              下载
            </Button>
            <Button type="primary" onClick={onClose}>
              关闭
            </Button>
          </Space>
        )
      }
    >
      {url && (
        <iframe
          src={url}
          title={preview?.title}
          style={{ width: '100%', height: 'calc(100vh - 220px)', border: 'none', borderRadius: 6 }}
        />
      )}
    </Modal>
  )
}

export default PdfPreviewModal
